import { Button, Icons } from '@commenda/kakashi';
import { cn } from '@commenda/utils';

interface EmptyStateV3Props {
  title: string;
  description: React.ReactNode;
  icon?: React.ReactNode;
  action?: {
    label: string;
    icon?: React.ReactNode;
    onClick: () => void;
  };
  className?: string;
}

function EmptyStateV3({
  title,
  description,
  action,
  icon,
  className,
}: EmptyStateV3Props) {
  return (
    <div
      className={cn(
        'flex items-center justify-center w-full rounded-xl p-5xl border border-border-primary-200 h-full min-h-[144px]',
        className
      )}
    >
      <div className="flex flex-col gap-4 items-center">
        {icon}
        <div className="flex flex-col items-center gap-1">
          <h3 className="txt-small-medium text-text-primary py-1">{title}</h3>
          <p className="txt-small-regular text-text-tertiary text-center text-balance">
            {description}
          </p>
        </div>
        {action ? (
          <Button
            variant="secondary"
            size="sm"
            className="bg-bg-secondary-200 border-border-secondary-600 display-sm-regular"
            onClick={action.onClick}
          >
            <Icons.Plus />
            <span className="txt-small-medium">{action.label}</span>
          </Button>
        ) : null}
      </div>
    </div>
  );
}

export { EmptyStateV3 };
